import type { PropsWithChildren } from 'react';

import { useOffice } from '@/components/providers/OfficeProvider';

export default function Devtools({ children }: PropsWithChildren) {
  const { isOfficeEnvironment } = useOffice();

  if (import.meta.env.PROD || isOfficeEnvironment) return children;

  return (
    <div className="flex min-h-screen w-full">
      <div className="flex w-full items-center justify-center bg-neutral-950 text-neutral-50">
        Devtools
      </div>
      <div className="flex w-80 min-w-80 flex-col">
        <div className="flex h-14 items-center bg-neutral-700 px-8 font-thin text-neutral-50">
          WeGroup AI Assistant
        </div>

        <div className="h-full">{children}</div>
      </div>
    </div>
  );
}
